<template>
  <div id="main" class="qrs-typography">
    <div id="app-container" class="app__container">
      <Calculator/>
    </div>
  </div>
</template>

<script>
import Calculator from './components/Calculator.vue'

export default {
  name: 'App',
  components: {
    Calculator
  }
}
</script>

<style>
  @import './assets/style/app.css';
</style>